module.exports = __webpack_public_path__ + "static/media/failIcon.8e139df1.svg";